<span>
  Version:
  {{ versionService.semverString ? versionService.semverString : 'N/A' }}
  ({{ versionService.buildDate | dateTimeToIso }})
</span>
